<!-- NOTE: This implements Fozzie `@justeat/f-header` Vue component with modifications -->
<!-- - It replaces Page Header's original Login/Logout implementation custom one -->
<!-- - It provides `userInfoData` to prevent API call to legacy `/api/account/details` -->
<template>
  <page-header
    :locale="appLocale"
    :is-order-count-supported="false"
    :show-login-info="true"
    :show-delivery-enquiry="false"
    :show-offers-link="false"
    :user-info-prop="userInfoData"
  />
</template>

<script>
import PageHeader from '@justeat/f-header'
import { mapGetters } from 'vuex'

export default {
  name: 'PageHeaderCustomNav',
  components: {
    PageHeader
  },
  data() {
    return {
      userInfoData: null,
      loginEventListener: null,
      logoutEventListener: null,
      loginLinkQuery: '[data-test-id="login-link"]',
      logoutLinkQuery: '[data-test-id="logout-link"]'
    }
  },
  computed: {
    ...mapGetters([
      'appLocale',
      'user'
    ])
  },
  mounted() {
    // Fetch user data if available
    this.$store.dispatch('fetchUser', this.$auth)

    // Set the initial user state
    this.setLoginState()
    // Listen for changes in the user state
    this.unwatch = this.$store.watch(
      state => state.user,
      newUser => {
        this.setLoginState(newUser)
      }
    )
  },
  beforeDestroy() {
    this.unwatch()
    // Clean up event listeners
    if (this.loginEventListener) {
      document.querySelector(this.loginLinkQuery).removeEventListener('click', this.handleLoginEvent)
      this.loginEventListener = null
    }
    if (this.logoutEventListener) {
      document.querySelector(this.logoutLinkQuery).removeEventListener('click', this.handleLogoutEvent)
      this.logoutEventListener = null
    }
  },
  methods: {
    handleLoginEvent: function handleLoginEvent(e) {
      e.preventDefault()
      // eslint-disable-next-line camelcase
      this.$auth.login({ returnUrl: window.location.pathname })
    },
    handleLogoutEvent: function handleLogoutEvent(e) {
      e.preventDefault()
      // eslint-disable-next-line camelcase
      this.$auth.logout({ returnUrl: window.location.pathname })
    },
    setLoginState: function setLoginState(user) {
      // If user is logged in, update userInfoData and customNavLinks
      if (user && user.isLoggedIn) {
        const { name, email, isLoggedIn } = user
        this.customNavLinks = []
        this.userInfoData = {
          friendlyName: name,
          isAuthenticated: isLoggedIn,
          email
        }

        // Hijack logout link
        this.$nextTick(() => {
          const logOutLink = document.querySelector(this.logoutLinkQuery)
          if (logOutLink && !this.logoutEventListener) {
            this.logoutEventListener = true
            logOutLink.addEventListener('click', e => {
              this.handleLogoutEvent(e)
            })
          }
        })
      } else {
        this.userInfoData = null

        // Hijack Log in link
        this.$nextTick(() => {
          const logInLink = document.querySelector(this.loginLinkQuery)
          if (logInLink && !this.loginEventListener) {
            this.loginEventListener = true
            logInLink.addEventListener('click', e => {
              this.handleLoginEvent(e)
            })
          }
        })
      }
    // }
    }
  }
}
</script>
